import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { NavBar } from '../../../../components/layout/NavBar'
import './VerifyEmail.module.css'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'
import { SubmitHandler, useForm } from 'react-hook-form'
import { RegistrationForm, VerifyEmailFormData, FormErrors } from './VerifyEmail.form'
import { MainLayout } from '@/components/layout/MainLayout'
import { CommunalHeader } from '@/components/layout/CommunalHeader'

export const VerifyEmailPage = ({ services }: { services: Services }) => {
  const navigate = useNavigate()
  const [data, setData] = useState<VerifyEmailFormData>()
  const [translates, setTranslates] = useState<Translates>()
  const [message, setMessage] = useState<string>()
  const [serverErrors, setServerErrors] = useState<FormErrors<VerifyEmailFormData>>()

  const form = useForm<VerifyEmailFormData>({
    defaultValues: data
  })

  const onSubmit = async (data: VerifyEmailFormData, resetForm: () => void) => {
    setMessage(undefined)
    const resp = await fetch(`/api/schema/users/register/verifyemail`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...data,
        lang: services.i18n.defaultLang()
      })
    })
    if (!resp.ok) {
      setServerErrors(await resp.json())
    } else {
      setMessage('page.verifyemail.success')
    }
  }

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [])


  if (translates === undefined) {
    return (<div className='spinner'></div>)
  }

  return <MainLayout services={services} translates={translates} pageName='verifyemail'>
    <CommunalHeader services={services} translates={translates} pageId='registration' />
    <div className='main-form main-form-single-col'>
      <div className='form-title'>{translates.for('page.verifyemail.formTitle')}</div>
      {message ? (<div className='form-message'>{translates.for(message)}</div>) : <RegistrationForm
        form={form}
        services={services}
        onSubmit={onSubmit}
        serverErrors={serverErrors}
      />}
    </div>
  </MainLayout>
}
